var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import { mapActions } from "vuex";
import VueDialog from "../../../interface/IVueDialog";
import BasicArcheivesService from '../../../api/BasicArcheivesService';
import CommonService from '../../../api/CommonService';
import ApplyClientsDialog from './ApplyClientsDialog.vue';
function setTreeData(treeData, id, name) {
    treeData.forEach(function (item) {
        item.id = item[id];
        item.name = item[name];
        if (item.children && item.children.length) {
            setTreeData(item.children, id, name);
        }
        ;
    });
}
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cascader_props = {
            multiple: true,
            value: 'id',
            label: 'name',
            emitPath: false
        };
        _this.cascader_propswww = {
            multiple: true,
            value: 'id',
            label: 'name',
            emitPath: false
        };
        _this.levelOptions = [
            { value: 5, label: '最高' },
            { value: 4, label: '高' },
            { value: 3, label: '中' },
            { value: 2, label: '低' },
            { value: 1, label: '最低' }
        ];
        _this.organList = [];
        _this.depot = {
            rule_name: '',
            organ_id: '',
            depot_id: '',
            city_id: [],
            goods_type_id: '',
            from_system: 1,
            level: 4,
            status: 1
        };
        _this.supplierdepotOptions = [];
        _this.areaList = [];
        _this.business_info = [];
        _this.business_info_name = '';
        _this.group_ids = [];
        _this.supplier_to_business_ids = [];
        _this.business_ids = [];
        _this.shop_ids = [];
        _this.extra_selected_city = [];
        _this.extra_selected_shop = [];
        return _this;
    }
    AddDialog.prototype.created = function () {
        var _this = this;
        this.service = BasicArcheivesService.getInstance();
        this.commonService = CommonService.getInstance();
        if (this.storeEditInfo) {
            this.depot = {
                rule_name: this.storeEditInfo.rule_name || '',
                organ_id: this.storeEditInfo.organ_id || '',
                depot_id: this.storeEditInfo.depot_id || '',
                city_id: this.storeEditInfo.city_id || [],
                goods_type_id: this.storeEditInfo.goods_type_id,
                from_system: this.storeEditInfo.from_system,
                level: this.storeEditInfo.level ? this.storeEditInfo.level : 4,
                status: this.storeEditInfo.status ? this.storeEditInfo.status : 1
            };
            this.business_info = this.storeEditInfo.business_info;
            this.business_info_name = this.storeEditInfo.business_info_name;
            this.group_ids = this.storeEditInfo.group_id;
            this.supplier_to_business_ids = this.storeEditInfo.supplier_to_business_id;
            this.business_ids = this.storeEditInfo.business_id;
            this.shop_ids = this.storeEditInfo.shop_id;
        }
        if (!this.depot['organ_id']) {
            this.depot['organ_id'] = this.organList && this.organList.length && this.organList[0].organ_id;
        }
        console.log('this.depot :>> ', this.depot);
        var loadingInstance = Loading.service({ fullscreen: true });
        Promise.all([
            this.getSupplierdepotOptions(),
            this.getArea()
        ]).then(function (result) {
            _this.getFilterData();
            loadingInstance.close();
        }).catch(function (error) {
            console.log(error);
        });
    };
    AddDialog.prototype.getFilterData = function () {
        var _this = this;
        console.log('depot', this.depot);
        if (this.depot.depot_id) {
            this.service.getStoreSplitFilterData({
                rule_id: this.storeEditInfo ? this.storeEditInfo.rule_id : null,
                from_system: this.depot.from_system,
                depot_id: this.depot.depot_id,
            }).then(function (res) {
                _this.extra_selected_city = res.data.data.extra_selected_city || [];
                _this.extra_selected_shop = res.data.data.extra_selected_shop || [];
                _this.calcAreaList();
            });
        }
    };
    AddDialog.prototype.calcAreaList = function () {
        var _this = this;
        var tempAreaList = JSON.parse(JSON.stringify(this.areaList));
        tempAreaList.forEach(function (item) {
            item.disabled = _this.extra_selected_city.indexOf(item.id) > -1;
            if (item.children && item.children.length) {
                item.children.forEach(function (item2) {
                    item2.disabled = _this.extra_selected_city.indexOf(item2.id) > -1;
                    if (item2.children && item2.children.length) {
                        item2.children.forEach(function (item3) {
                            item3.disabled = _this.extra_selected_city.indexOf(item3.id) > -1;
                        });
                    }
                });
            }
        });
        this.areaList = tempAreaList;
        console.log('this.areaList updated', this.areaList);
    };
    AddDialog.prototype.visibleChangeShop = function (type) {
        if (type === false) {
        }
    };
    AddDialog.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        return this.commonService.getSupplierdepotOptions({
            organ_id: this.depot.organ_id,
            is_init: 1
        }).then(function (res) {
            if (res.data.success) {
                if (!res.data.data || !res.data.data.length) {
                    _this.supplierdepotOptions = [];
                    return;
                }
                _this.supplierdepotOptions = res.data.data;
                if (!_this.storeEditInfo) {
                    (res.data.data || []).some(function (item) {
                        if (item.is_organ_default == 1) {
                            _this.depot.depot_id = item.depot_id;
                            return true;
                        }
                        _this.depot.depot_id = '';
                    });
                }
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    AddDialog.prototype.dealDataForFlat = function (flatData) {
        var _this = this;
        return flatData.reduce(function (pre, cur) {
            return pre.concat(Array.isArray(cur.children) ? _this.dealDataForFlat(cur.children) : cur.id);
        }, []);
    };
    AddDialog.prototype.changeDepotId = function (val) {
        var _this = this;
        this.depot.city_id = [];
        this.$nextTick(function () {
            _this.getFilterData();
        });
    };
    AddDialog.prototype.getArea = function () {
        var _this = this;
        return this.commonService.getArea().then(function (res) {
            var data = res.data;
            if (data.success) {
                data.data[0].name = "全部城市";
                _this.areaList = [data.data[0]];
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddDialog.prototype.changeOrganId = function (_) {
        var _this = this;
        this.depot.city_id = [];
        this.getSupplierdepotOptions().then(function () {
            if (_this.depot.depot_id) {
                _this.getFilterData();
            }
        });
    };
    AddDialog.prototype.applyClients = function () {
        var _this = this;
        var dialog = this.$dialog(ApplyClientsDialog, {
            data: {
                group_ids: this.group_ids,
                shop_ids: this.shop_ids,
                business_ids: this.business_ids,
                supplier_to_business_ids: this.supplier_to_business_ids,
                needCheckedIsTemp: false,
                extra_selected_shop: this.extra_selected_shop
            },
            showEmpty: true
        }, {
            title: "选择客户",
            width: 640,
            height: 530
        });
        dialog.instance.$on("submit", function (res) {
            console.log('res :>> ', res);
            _this.business_info = res.business_info;
            _this.business_info_name = res.business_info_name;
            _this.group_ids = res.group_ids;
            _this.supplier_to_business_ids = res.supplier_to_business_ids;
            _this.business_ids = res.business_ids;
        });
    };
    AddDialog.prototype.mounted = function () {
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        console.log('this.depot :>> ', this.depot);
        if (!this.depot.rule_name) {
            this.$message.error("请输入规则名称");
            return;
        }
        ;
        if (!this.depot.organ_id) {
            this.$message.error("请选择所属机构");
            return;
        }
        ;
        if (!this.depot.depot_id) {
            this.$message.error("请选择所属仓库");
            return;
        }
        ;
        if (!this.depot.city_id.length) {
            this.$message.error("请选择城市");
            return;
        }
        ;
        var list = this.business_info.filter(function (item) {
            return item.children && item.children.length;
        }) || [];
        var isSelectShop = list.length ? true : false;
        if (!isSelectShop) {
            this.$message.error("请选择服务客户");
            return;
        }
        ;
        var params = {
            rule_name: this.depot.rule_name,
            organ_id: this.depot.organ_id,
            depot_id: this.depot.depot_id,
            business_info: JSON.stringify(this.business_info),
            goods_type_id: JSON.stringify(this.depot.goods_type_id),
            city_id: JSON.stringify(this.depot.city_id),
            from_system: this.depot.from_system,
            level: this.depot.level,
            status: this.depot.status
        };
        if (this.storeEditInfo) {
            var data = {
                rule_id: this.storeEditInfo.rule_id
            };
            Object.assign(data, params);
            this.updateStore(data);
        }
        else {
            this.addStore(params);
        }
    };
    AddDialog.prototype.addStore = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.addStoreSplit(params).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功！');
                _this.$closeDialog();
                _this.$emit('addClient:ok', {
                    depot_id: res.data.data,
                    organ_id: _this.depot.organ_id
                });
            }
            else {
                var msg = res.data.msg.length > 200 ? res.data.msg.slice(0, 200) + '...' : res.data.msg;
                _this.$message.error({
                    message: msg,
                    duration: 2000
                });
            }
            ;
            loadingInstance.close();
        }).catch(function (err) {
            var msg = err.message.length > 200 ? err.message.slice(0, 200) + '...' : err.message;
            _this.$message.error({
                message: msg,
                duration: 2000
            });
            loadingInstance.close();
        });
    };
    AddDialog.prototype.updateStore = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.updateStoreSplit(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$message.success('修改成功！');
                _this.$closeDialog();
                _this.$emit('addClient:ok');
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddDialog = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
